import { useEffect } from 'react';
var activeScrollLocks = 0;
var previousBodyOverflow;
var acquireScrollLock = function acquireScrollLock() {
  if (typeof document === 'undefined') {
    return function () {};
  }
  activeScrollLocks += 1;
  if (activeScrollLocks === 1) {
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  var released = false;
  return function () {
    if (released) {
      return;
    }
    released = true;
    if (typeof document === 'undefined') {
      return;
    }
    activeScrollLocks = Math.max(0, activeScrollLocks - 1);
    if (activeScrollLocks === 0 && previousBodyOverflow !== undefined) {
      document.body.style.overflow = previousBodyOverflow;
      previousBodyOverflow = undefined;
    }
  };
};
export var useBlockScroll = function useBlockScroll(shouldBlockScroll) {
  useEffect(function () {
    if (!shouldBlockScroll) {
      return undefined;
    }
    return acquireScrollLock();
  }, [shouldBlockScroll]);
};